<template>
    <div class="learningpath-banner-details">
        <span class="learningpath-banner-details__item">
            <span class="icon-stackoverflow"></span>
            <span class="learningpath-banner-details__label" v-html="$t('BannerCollectionInfo.course_count')"></span>
            <span class="learningpath-banner-details__amount">{{ amountOfCourses }}</span>
        </span>
        <span class="learningpath-banner-details__item">
            <span class="icon-clock"></span>
            <span class="learningpath-banner-details__label" v-html="$t('BannerCollectionInfo.total_duration')"></span>
            <span class="learningpath-banner-details__amount">
                {{ convertMinutesToHours(duration) }}
            </span>
        </span>
        <span class="learningpath-banner-details__item" v-if="showRecommendedPace">
            <span class="icon-meter"></span>
            <span class="learningpath-banner-details__label" v-html="$t('LearningPath.recommended_pace')"></span>
            <span class="learningpath-banner-details__amount">
                {{ recommendedPace }}
            </span>
        </span>
        <div class="learningpath-banner-details__authorizations">
            <span v-for="(authorization, index) in authorizations"
                  :key="index"
                  class="learningpath-banner-details__item"
            >
                <TotemCertificationBadge :name="authorization.authorizationName" size="small" />
                <span class="learningpath-banner-details__amount">
                    {{ authorization.authorizationPoints }}
                </span>
            </span>
        </div>
    </div>
</template>

<script>
    import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [ convertMinutesToHours ],
        props: {
            duration: Number,
            amountOfCourses: Number,
            authorizationPoints: Array,
            recommendedPace: String

        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn'
            }),
            authorizations () {
                return this.authorizationPoints.filter(authorization => authorization.authorizationPoints > 0)
            },
            showRecommendedPace () {
                return this.recommendedPace && this.recommendedPace.trim().length > 0
            }
        }
    }
</script>

<style lang="scss" scoped>
    .learningpath-banner-details {
        font-size: 1.5rem;
        background: $heavy_metal;
        color: $white;
        display: flex;
        flex-direction: column;
        border-top: 1px solid $white;

        [class*="desktop"] & {
            flex-direction: row;
            min-height: 60px;
        }

        span[class*="icon-"] {
            font-size: 1.8rem;
            margin: 0 15px 0 0;
            color: $orange;
        }

        &__item {
            font-size: 1.8rem;
            display: flex;
            align-items: center;
            padding: 10px 20px;
            border-bottom: 1px solid $white;

            [class*="desktop"] & {
                padding: 0 30px;
                border-right: 1px solid $white;
                border-bottom: none;
            }
        }

        &__label {
            font-size: 1.6rem;
            [class*="mobile"] & {
                font-size: 1.6rem;
            }
        }
        &__amount {
            font-size: 2rem;
            padding: 0 0 0 8px;
            line-height: 1;
            [class*="mobile"] & {
                font-size: 1.6rem;
            }
        }

        &__authorizations {
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;

            [class*="desktop"] & {
                flex-direction: row;
            }

            .learningpath-banner-details__item {
                flex: 1;
            }
        }
    }
</style>
